import {
  GenericWorkflowAction,
  WorkflowCriteriaVariableSchemas,
  WorkflowFilterFieldConfigs,
  WorkflowOperators,
} from 'dashboard/models/workflow-schema';
import {
  WorkflowSchemaActions,
  WorkflowSchemaActionType,
} from 'dashboard/redux/actions/workflow-schema';
import { ObjectSchemaMap } from 'dashboard/redux/slices/object-schemas';
import { ApiModel } from 'lib/interfaces/api';

export type WorkflowSchemaState = {
  readonly 'criteria-variable-schemas': WorkflowCriteriaVariableSchemas;
  readonly operators: WorkflowOperators;
  readonly 'filter-field-configs': WorkflowFilterFieldConfigs;
  readonly 'generic-workflow-actions': GenericWorkflowAction[];
  readonly primitives: ObjectSchemaMap;
};

export const initialState: WorkflowSchemaState = {
  'criteria-variable-schemas': {},
  operators: {},
  'filter-field-configs': {
    [ApiModel.Account]: [],
    [ApiModel.Case]: [],
    [ApiModel.Inquiry]: [],
    [ApiModel.Report]: [],
    [ApiModel.SAR]: [],
    [ApiModel.Transaction]: [],
  },
  'generic-workflow-actions': [],
  primitives: {},
};

export default (state: WorkflowSchemaState = initialState, action: WorkflowSchemaActions) => {
  switch (action.type) {
    case WorkflowSchemaActionType.AppendCriteriaVariableSchemas: {
      return {
        ...state,
        'criteria-variable-schemas': {
          ...state['criteria-variable-schemas'],
          ...action.payload.criteriaVariableSchemas,
        },
      };
    }

    case WorkflowSchemaActionType.ClearCriteriaVariableSchemas: {
      return {
        ...state,
        'criteria-variable-schemas': {},
      };
    }

    case WorkflowSchemaActionType.SetCriteriaVariableSchemas: {
      return {
        ...state,
        'criteria-variable-schemas': action.payload.criteriaVariableSchemas,
      };
    }

    case WorkflowSchemaActionType.SetFilterFieldConfigs: {
      return {
        ...state,
        'filter-field-configs': action.payload.filterFieldConfigs,
      };
    }

    case WorkflowSchemaActionType.SetOperators: {
      return {
        ...state,
        operators: action.payload.operators,
      };
    }

    case WorkflowSchemaActionType.SetWorkflowActions: {
      return {
        ...state,
        'generic-workflow-actions': action.payload.genericWorkflowActions,
      };
    }

    case WorkflowSchemaActionType.ClearSchema: {
      return initialState;
    }

    case WorkflowSchemaActionType.SetPrimitives: {
      return {
        ...state,
        primitives: action.payload.primitives,
      };
    }

    default:
      return state;
  }
};
